<template>
  <RouterView />
  <BaseToast />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import BaseToast from '@/components/BaseToast.vue'
</script>

<style scoped></style>
